import './styles.scss';

const VideoPlayer = ({ url, title }) => {
    if (!url) return null;

    // Extract video ID from various YouTube URL formats
    const getYouTubeVideoId = (videoUrl) => {
        if (!videoUrl) return null;

        const trimmedUrl = videoUrl.trim();
        let videoId = null;

        // Format: https://www.youtube.com/embed/VIDEO_ID
        const embedMatch = trimmedUrl.match(/youtube\.com\/embed\/([a-zA-Z0-9_-]+)/i);
        if (embedMatch) {
            videoId = embedMatch[1];
        }

        // Format: https://www.youtube.com/watch?v=VIDEO_ID
        if (!videoId) {
            const watchMatch = trimmedUrl.match(/youtube\.com\/watch\?v=([a-zA-Z0-9_-]+)/i);
            if (watchMatch) {
                videoId = watchMatch[1];
            }
        }

        // Format: https://youtu.be/VIDEO_ID
        if (!videoId) {
            const shortMatch = trimmedUrl.match(/youtu\.be\/([a-zA-Z0-9_-]+)/i);
            if (shortMatch) {
                videoId = shortMatch[1];
            }
        }

        // Format: https://www.youtube.com/shorts/VIDEO_ID
        if (!videoId) {
            const shortsMatch = trimmedUrl.match(/youtube\.com\/shorts\/([a-zA-Z0-9_-]+)/i);
            if (shortsMatch) {
                videoId = shortsMatch[1];
            }
        }

        return videoId;
    };

    const videoId = getYouTubeVideoId(url);

    if (!videoId) {
        return (
            <div className="video-player-container">
                <div className="video-player-error">
                    <p>Unable to load video. <a href={url} target="_blank" rel="noopener noreferrer">Watch on YouTube</a></p>
                </div>
            </div>
        );
    }

    return (
        <div className="video-player-container">
            {title && <div className="video-player-title">{title}</div>}
            <div className="video-player-wrapper">
                <iframe
                    className="video-player"
                    src={`https://www.youtube.com/embed/${videoId}?modestbranding=1&rel=0`}
                    title={title || "YouTube video player"}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                />
            </div>
            {/* <div className="video-player-footer">
                <a
                    href={`https://www.youtube.com/watch?v=${videoId}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="watch-on-youtube"
                >
                    Watch on YouTube
                </a>
            </div> */}
        </div>
    );
};

export default VideoPlayer;
